module.exports = __webpack_public_path__ + "static/media/checkin_bg.386fc937.png";